import React from 'react';
import { Tag, Input, Select, Switch, Button } from 'antd'
import moment from 'moment';
import userService from './UserService';

const statusMap = {
    0: 'Not Sent',
    1: 'Sent - Unused',
    2: 'Sent - Used'
}

const roleMap = {
    'admin': 'Admin',
    'user': 'User'
}

export const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: (a, b) => a.name.localeCompare(b.name),
        shouldUseAsfilter: true,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        sorter: (a, b) => a.email.localeCompare(b.email),
        shouldUseAsfilter: true
    },
    {
        title: 'Role',
        dataIndex: 'roles',
        key: 'roles',
        render: (roles) => { return roles.map(r => roleMap[r]).join(', ') },
        shouldUseAsfilter: true,
        filterComponent: ({ onChange }) => <Select style={{ width: 300 }} placeholder="Select User Type" onChange={onChange}>
            {
                Object.keys(roleMap).map((value, index) => {
                    let text = roleMap[value];
                    return <Select.Option key={`select-user-type-${index}`} value={value}>{text}</Select.Option>
                })
            }
        </Select>
    },
    {
        title: 'Joined',
        dataIndex: 'dateJoined',
        key: 'joined',
        sorter: (a, b) => a.dateJoined.localeCompare(b.dateJoined),
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
    },
    {
        title: 'Last Login',
        dataIndex: 'lastLogin',
        key: 'lastLogin',
        sorter: (a, b) => a.lastLogin.localeCompare(b.lastLogin),
        render: (d) => { return moment(d).format('M/D/YYYY @ H:M:SS A') },
    },
    {
        title: 'Debug',
        dataIndex: 'debug',
        key: 'debug',
        render: (d) => { return String(d || "") },
    },
    // {
    //     title: 'Invitation Status',
    //     dataIndex: 'status',
    //     key: 'status',
    //     render: (text) => <Tag color={+text === 0 ? 'red' : +text === 1 ? 'orange' : +text === 2 ? 'green' : 'yellow'}>{statusMap[text] || 'Data Unavailable'}</Tag>,
    //     shouldUseAsfilter: true,
    //     filterComponent: ({ onChange }) => <Select style={{ width: 300 }} placeholder="Select Invitation Status" onChange={onChange}>
    //         {
    //             Object.keys(statusMap).map((key, index) => {
    //                 let text = roleMap[key];
    //                 return <Select.Option key={`invitation-status-${index}`} value={+key}>{text}</Select.Option>
    //             })
    //         }
    //     </Select>
    // },
];

export const formSchema = [
    {
        props: {
            name: "name",
            label: "Name"
        },
        component: Input,
    },
    {
        props: {
            name: "password",
            label: "Password"
        },
        component: ({ form, formDefaultValue, done }) => {
            const onResetPassword = async () => {
                const password = prompt("Please enter your new password:");
                await userService.changePassword({ password, email: form.getFieldValue("email") })
            }
            return (
                <div>
                    <Button disabled={formDefaultValue?._id === "new"} type="primary" onClick={onResetPassword}>Update Password</Button>
                </div>
            )
        }
    },
    {
        props: {
            name: "roles",
            label: "Role"
        },
        component: Select,
        componentProps: {
            style: { width: 300 },
            placeholder: "Roles",
            mode: "multiple",
            allowClear: true,
            defaultValue: ['user'], //Object.keys(Categories),
            children: Object.keys(roleMap).map((key, i) => <Select.Option key={i} value={key}
                checked style={{ textTransform: 'capitalize' }}>{roleMap[key]}</Select.Option>)

            //children: Object.values(roleMap).map(value => <Select.Option key={value} value={value}>{value}</Select.Option>)
        }
        // component: 'div',
        // componentProps: {
        //     children:   [
        //         <small>(Roles available: {Object.keys(roleMap).join(', ')})</small>,
        //         <br/>,
        //         <Select placeholder="Roles" mode="multiple" defaultValue={['user']} style={{ width: 300 }}>
        //             { Object.keys(roleMap).map((key, i) => { return <Select.Option key={i} value={key}
        //             checked style={{ textTransform: 'capitalize' }}>{roleMap[key]}</Select.Option> })}
        //         </Select>,
        //     ]
        //     //children: Object.values(roleMap).map(value => <Select.Option key={value} value={value}>{value}</Select.Option>)
        // }
    },
    {
        props: {
            name: "email",
            label: "Email"
        },
        component: Input
    },
    {
        props: {
            name: "active",
            label: "Is Active?"
        },
        component: (props) => {
            const { value, ...otherProps } = props;
            return <Switch {...otherProps} defaultChecked={1} checked={value} />
        },
        componentProps: {
            type: "boolean"
        },
    },
    {
        props: {
            name: "debug",
            label: "Debug?"
        },
        component: ({ value, ...otherProps }) => {
            console.log(value);
            return <Switch {...otherProps} defaultChecked={1} checked={!!value} />
        },
        componentProps: {
            type: "boolean"
        },
    },
    // {
    //     props: {
    //         name: "status",
    //         label: "Send Invitation"
    //     },
    //     component: (props)=>{
    //         const {value, ...otherProps} = props;
    //         return <Switch {...otherProps} defaultChecked={1} checked={value}/>
    //     },
    // },
]
